import moment from "moment-timezone";

function getSuffix() {
  return moment(new Date()).clone().utc().format().substr(19, 6);
}

export function parseStringDate(dateString){
  const milliseconds = Date.parse(dateString);
  return new Date(milliseconds);
}

export function dateBetween(date, compare1, compare2) {
  if (
    date.getTime() >= compare1.getTime() &&
    date.getTime() <= compare2.getTime()
  ) {
    return true;
  }
  return false;
}

export function isSame(date1, date2) {
  return moment(date1).format("l") == moment(date2).format("l");
}

export function parseDatetimelocal(date) {
  return moment(date, moment.DATETIME_LOCAL).format();
}

export function firstDateOfCurrentYear() {
  let current_date = new Date();
  let year = current_date.getFullYear();
  return moment.parseZone(year + "-" + "01-01T00:00:00" + getSuffix()).format();
}

export function firstDateOfCurrentMonth() {
  let current_date = new Date();
  let year = current_date.getFullYear();
  let month = current_date.getMonth() + 1;
  if (month < 10) {
    return moment
      .parseZone(year + "-0" + month + "-01T00:00:00" + getSuffix())
      .format();
  }
  return moment
    .parseZone(year + "-" + month + "-01T00:00:00" + getSuffix())
    .format();
}

export function currentDate() {
  let current_date = new Date();
  let year = current_date.getFullYear();
  let month = current_date.getMonth() + 1;
  let day = current_date.getDate();
  if (month < 10) {
    month = "0" + month;
  }

  if (day < 10) {
    day = "0" + day;
  }
  return moment
    .parseZone(year + "-" + month + "-" + day + "T00:00:00" + getSuffix())
    .format();
}

export function currentYear() {
  let current_date = new Date();
  return current_date.getFullYear();
}

export function parseDate(date) {
  return date + "T00:00:00+00:00";
}

export function parseEndDate(date) {
  return date + "T23:59:59+00:00";
}

export function formatDate(date) {
  if (!date) return null;
  const [year, month, day] = date.substr(0, 10).split("-");
  return `${year}-${month}-${day}`;
}

export function formatDateHour(date) {
  if (!date) return null;
  const [hh, mm] = date.substr(11, 16).split(":");
  return `${hh}:${mm}`;
}

export function formatInfoDate(date, locale) {
  moment.locale(locale);
  return moment(date).format("LLL");
}

export function formatSinceDate(date, locale) {
  moment.locale(locale);
  return moment(date).format("L");
}

export function formatMagicDate(date, locale) {
  if (date == "") {
    return "";
  }

  if (date == undefined) {
    return "";
  }

  if (date == null) {
    return "";
  }
  moment.locale(locale);
  return moment(date).format("L");
}

Date.prototype.addDays = function (noOfDays) {
  var tmpDate = new Date(this.valueOf());
  tmpDate.setDate(tmpDate.getDate() + noOfDays);
  return tmpDate;
};

Date.prototype.addMonth = function (noOfMonth) {
  var tmpDate = new Date(this.valueOf());
  tmpDate.setMonth(tmpDate.getMonth() + noOfMonth);
  return tmpDate;
};

export function addMonthToDate(month, date = new Date()) {
  return moment(date.addMonth(month)).format();
}

export function getMomentDate(date = new Date()) {
  return moment(date).format();
}

export function getTimelineDefaultPeriod() {
  let start = new Date();
  let end = new Date();
  let period = {
    start: moment(start.addDays(-120)).format(),
    end: moment(end.addDays(60)).format(),
  };
  return period;
}


export function getDefaultPeriod() {
  let start = new Date();
  let end = new Date();
  let period = {
    start: moment(start.addDays(-365)).format('YYYY-MM-DD'),
    end: moment(end.addDays(60)).format('YYYY-MM-DD'),
  };
  return period;
}

export function getTimelineViewPeriod() {
  let start = new Date();
  let end = new Date();
  let period = {
    start: moment(start.addDays(-20)).format(),
    end: moment(end.addDays(10)).format(),
  };
  return period;
}

/**
 * Arrondit `value` à `n` décimales.
 *
 * @param {number} value – le nombre à arrondir
 * @param {number} n     – nombre de chiffres après la virgule souhaités
 * @returns {number}     – nombre arrondi à n décimales
 */
export function arrondirDecimales(value, n) {
  const facteur = Math.pow(10, n);
  return Math.round(value * facteur) / facteur;
}

export function numStr(a, b) {
  a = "" + a;
  b = b || " ";
  var c = "",
    d = 0;
  while (a.match(/^0[0-9]/)) {
    a = a.substr(1);
  }
  for (var i = a.length - 1; i >= 0; i--) {
    c = d != 0 && d % 3 == 0 ? a[i] + b + c : a[i] + c;
    d++;
  }
  return c;
}

export function formatTimelinePoiToolTipTime(date, locale) {
  if (date == "") {
    return "";
  }

  if (date == undefined) {
    return "";
  }

  if (date == null) {
    return "";
  }
  moment.locale(locale);
  return moment(date).format("LT");
}

export function currentDateTime() {
  return moment(new Date()).format("YYYY-MM-DDTHH:mm:ss");
}

export function getMonthDetails(year, month, locale) {
  let calendar = [];
  let week = 1;
  let lastDate = new Date(Date.UTC(year, month, 0));
  let firstDate = new Date(Date.UTC(year, month - 1, 1));
  moment.locale(locale);

  calendar.push({
    week: week,
    longdate: firstDate,
    date: moment(firstDate).format("dddd-DD"),
  });

  let nextdate = firstDate.addDays(1);

  for (var i = 0; i < lastDate.getDate() - 1; i++) {
    if (nextdate.getDay() == 1) {
      week++;
    }
    calendar.push({
      week: week,
      longdate: nextdate,
      date: moment(nextdate).format("dddd-DD"),
    });
    nextdate = nextdate.addDays(1);
  }

  return calendar;
}

export function isDateRangeOverlapping(range1, range2) {
  const [start1, end1] = range1;
  const [start2, end2] = range2;

  // Vérifier si les plages se chevauchent partiellement ou totalement
  const isOverlapping = start1 <= end2 && end1 >= start2;

  // Vérifier si range2 est totalement incluse dans range1
  const isFullyContained = start1 <= start2 && end1 >= end2;

  return isOverlapping || isFullyContained
}


export function isDateRangeOverlapping2(range1, range2) {
  const [start1, end1] = range1;
  const [start2, end2] = range2;

  // Vérifier si les plages se chevauchent partiellement ou totalement
  const isOverlapping = start1 <= end2 && end1 >= start2;

  // Vérifier si range2 est totalement incluse dans range1
  const isFullyContained = start1 <= start2 && end1 >= end2;

  return {
      partiallyOverlapping: isOverlapping,
      fullyContained: isFullyContained
  };
}

